export const registrationErrorMessage = (error, fallback) => {
  const status = error.response?.status;
  if (status === 429) {
    return "Too many attempts. Please wait a minute before trying again.";
  }
  if (status >= 500) {
    return "The server could not complete your request. Please try again shortly.";
  }
  const data = error.response?.data;
  if (typeof data?.message === "string" && data.message.trim()) {
    return data.message;
  }
  if (!error.response && error.request) {
    return "Unable to connect to the server. Check your internet connection and try again.";
  }
  return fallback;
};
